import React from 'react';
import styles from '../styles/Newsletter.module.css';

const Newsletter = () => (
  <section className={styles.newsletter} aria-labelledby="newsletter-title">
    <p id="newsletter-title" className={styles.intro}>
      Sie möchten von neuen Broten, saisonalen Angeboten und Veranstaltungen erfahren? Hinterlassen Sie uns gerne Ihre E-Mail-Adresse – wir informieren Sie persönlich über Neuigkeiten von Grain Bites.
    </p>

    <form className={styles.form}>
      <div className={styles.inputGroup}>
        <span className={styles.inputAddon} aria-hidden="true">@</span>
        <input
          className={styles.emailInput}
          id="newsletter"
          name="email"
          type="email"
          placeholder="e-mail"
        />
      </div>

      <button className={styles.submit} type="submit">Submit</button>

      <label className={styles.consentLabel}>
        <input className={styles.consentInput} type="radio" name="radio1" required />
        <span>
          Mit der Erhebung, Speicherung und Nutzung meiner personenbezogenen Daten zur Kontaktaufnahme durch Grain Bites Catering erkläre ich mich einverstanden. Die Datenschutzhinweise habe ich zur Kenntnis genommen und verstanden.
        </span>
      </label>
    </form>
  </section>
);

export default Newsletter;
